export default __webpack_public_path__ + "8def5cc3a40aef9937177752462cd6ab.png";